<template>
  <form v-on:submit.prevent="submitForm">
    <div v-if="region === null">
      Not loaded yet
    </div>
    <div v-else>
      <h2>Region</h2>
      <div class="form-group"><label for="id">ID :</label><input class="form-control" id="id" readonly="readonly" v-model="region.id"/></div>
      <div class="form-group"><label for="name">Name : </label><input class="form-control" id="name" v-model="region.name"/></div>
      <div class="form-group"><label for="thirdIdRegion">Third Id Region : </label><input class="form-control" id="thirdIdRegion" v-model="region.thirdIdRegion"/></div>
      <div class="form-group"><label for="begin">Begin : </label><input class="form-control" id="begin" v-model="region.begin"/></div>
      <div class="form-group"><label for="end">End : </label><input class="form-control" id="end" v-model="region.end"/></div>
      <div>
        <p>
          <input class="btn btn-edit" type="submit" value="Submit">
        </p>

        <p class="btn btn-deprecate" @click="deprecateRegion()">
          <v-icon> mdi-clock </v-icon>
          <input class="btn" value="Deprecate">
        </p>

        <p>
          <router-link class="btn btn-cancel" v-bind:to="{path: 'regions'}">
            <v-icon>mdi-cancel</v-icon>
            <input class="btn" type="submit" value="Cancel">
          </router-link>
        </p>
      </div>
    </div>
  </form>
</template>

<script>
import {parameters} from "../../parameters";
import {httpClient} from "../../requesters/httpClient";

export default {
  name: 'EditRegion',

  async created() {
    await httpClient.get(`${parameters.posdataRefUrl}/regions/` + this.$route.query.id)
      .then((response)=> {
        this.region = response.data;
      })
      .catch((error)=> {
        throw error;
      });
  },
  data() {
    return {
      region : null
    }
  },
  methods: {
    async submitForm(e) {

      if (!this.areFieldsEmpty()){
        await httpClient.post(`${parameters.posdataRefUrl}/overwrite/region`, this.region);

        await this.$alert("The region was overwritten THEN updated");

        await this.$router.push('regions');

      e.preventDefault();
      } else {
        await this.$alert("Some mandatory fieds are empty")
      }
    },
    areFieldsEmpty: function(){
      if (this.region.thirdIdRegion === '' || this.region.name === ''){
        return true;
      }
    },
    async deprecateRegion(){
      await httpClient.post(`${parameters.posdataRefUrl}/region/` + this.region.id + `/deprecate`)
        .then(function (response){
          if (response.status === 200){
            alert("The region was deprecated")
          } else {
            alert("Region is not present in database and can't be deprecated")
          }

        })
      await this.$router.push('regions')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/regions/EditRegion.vue